<div class="modal-header">
  <h4 class="modal-title">Bulk Add Customers To Association</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <ng-container *ngIf="!loadingSave">
    <div class="form-group">
      <label for="associationSearchInput">Association</label>
      <input type="text" class="form-control" id="associationSearchInput" name="associationSearchInput"
             [(ngModel)]="associationSearchInput"
             (ngModelChange)="selectedAssociation = null">
    </div>

    <!-- Add a fixed-height div to prevent the modal from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto"
         *ngIf="selectedAssociation === null">

      <table class="table table-bordered table-hover">
        <tbody>
        <ng-container *ngIf="associations.length === 0">
          <tr>
            <td>No associations have been created.</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="associations.length > 0">
          <tr *ngFor="let association of getMatchedAssociations()"
              class="cursor-pointer"
              (click)="selectAssociation(association)">
            <td>{{ association.name }}</td>
          </tr>
          <tr *ngIf="getMatchedAssociations().length === 0">
            <td>No associations found.</td>
          </tr>
        </ng-container>
        </tbody>
      </table>

    </div>
  </ng-container>

  <ng-container *ngIf="loadingSave">
    <h4>Loading...</h4>

    <div class="progress">
      <div class="progress-bar" role="progressbar" [style]="{width: getLoadingProgressPercentageStr() + '%'}"
           attr.aria-valuenow="{{ getLoadingProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </ng-container>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button type="button" class="btn btn-primary"
          [disabled]="!saveButtonEnabled()"
          [class.disabled]="!saveButtonEnabled()"
          (click)="handleSubmit()">
    {{ loadingSave ? 'Loading...' : 'Save' }}
  </button>
</div>
